import React, { useState, useEffect } from 'react'
import { getLogsList } from './ActionCreator';
import Loader from '../../../presentationals/Loader/Loader.component'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../images/nodata.png'

const size = 10;
export default function Logs() {
    const [loader, setLoader] = useState(false)
    const [currentPage, setcurrentPage] = useState(1)
    const [listData, setListData] = useState([])
    const [totalPages,setTotalPages] =useState(0)

    useEffect(() => {
        getLogsListFn(currentPage)
    }, [])

    const getLogsListFn = (page) => {
        setLoader(true)
        getLogsList((page-1), size, callback => {
            setLoader(false)
            setListData(callback?.content)
            setTotalPages(callback?.totalPages)
        })
    }

    const handlePagePagination = (event, value) => {
        setcurrentPage(value);
        getLogsListFn(value)
    };

    return (
        <>
            <div className="container-fluid" style={{ margin: '100px 0 40px 0' }}>
                {
                    loader ? <Loader /> : ''
                }

                <div className="row">
                    <div className="col-sm-12 col-xs-12">
                        
                        {listData !== '' && listData?.length > 0 ?
                            <>
                                <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '15px' }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Communication Id</th>
                                                <th className='text-center'>Step Id</th>
                                                <th className='text-center'>Communication Type</th>
                                                <th className='text-center'>status</th>
                                                {/* <th className='text-center'>content</th> */}
                                                <th className='text-center'>communicate To</th>
                                                {/* <th className='text-center'>vendor Id</th> */}
                                                <th className='text-center'>Added On</th>
                                               
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listData && listData?.length > 0 ? listData?.map((data, i) => (
                                                <tr key={i}>
                                                    <td className='text-center'>{data?.communicationId}</td>
                                                    <td className='text-center'>{data?.stepId}</td>
                                                    <td className='text-center'>{data?.type}</td>
                                                    <td className='text-center'>{data?.status}</td>
                                                    {/* <td className='text-center'>{data?.content}</td> */}
                                                    <td className='text-center'>{data?.communicateTo}</td>
                                                    {/* <td className='text-center'>{data?.vendorId}</td> */}
                                                   
                                                    <td className='text-center'>{data?.creationDate}</td>
                                                   </tr>
                                            )) : ""}
                                        </tbody>
                                    </table>
                                    <div style={{ float: "right", marginTop: '20px' }}>
                                        <Pagination
                                            count={totalPages}
                                            page={currentPage}
                                            onChange={handlePagePagination}
                                            color="primary"
                                        />
                                    </div>
                                </div>
                            </>
                            :
                            <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>}


                    </div>
                </div>

            </div>
        </>
    )
}
